import { MAIN } from "../../../routes/constants";
import ContactList from "./ContactList";
import ViewContact from "./ViewContact";

//Module Page Routes
export const CONTACT_LIST = MAIN + "/PartnerContacts";
export const VIEW_CONTACT = MAIN + "/PartnerContacts/view";

const MobileContactRoutes = [
    {
        label: "PARTNER CONTACTS",
        path: CONTACT_LIST,
        component: ContactList,
        exact: true,
        mainscreen: true
    },
    {
        label: "VIEW CONTACTS",
        path: VIEW_CONTACT + "/:id?",
        component: ViewContact,
        exact: true,
        mainscreen: true
    },
];

export default MobileContactRoutes;